export const ADVISOR_MESSAGE_TIMEOUT_MS = 60_000;

let advisorRequestSequence = 0;
let latestAdvisorRequestId = 0;

export function beginAdvisorRequest(): number {
  const requestId = ++advisorRequestSequence;
  latestAdvisorRequestId = requestId;
  return requestId;
}

export function isLatestAdvisorRequest(requestId: number): boolean {
  return latestAdvisorRequestId === requestId;
}
